/* eslint-disable camelcase */
import PropTypes from 'prop-types';

import { propTypesLink } from '../../../constants/Proptypes';

const propTypesSliceEventCards = {
  event_cards_title: PropTypes.string,
  is_title_centered: PropTypes.bool,
};

const propTypesItemsEventCards = {
  event_cards_pages: PropTypes.shape(propTypesLink),
};

export const propTypesDataEventCards = {
  id: PropTypes.string,
  slice_type: PropTypes.string,
  slice_label: PropTypes.string,
  primary: PropTypes.shape(propTypesSliceEventCards),
  items: PropTypes.arrayOf(PropTypes.shape(propTypesItemsEventCards)),
};
